module.exports = __webpack_public_path__ + "img/18-s.e137094c.png";